let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lA7Ru")).then(() => parcelRequire('ecDM5'));